module.exports = __webpack_public_path__ + "img/cloudBalloonTriangle.c8d86b51.svg";